export type CategoryBaseEvent = typeof CATEGORY_BASE_EVENT;

export const CATEGORY_BASE_EVENT = `category:hack`;

export const ORGANIZE_ASSETS_EVENT_PREFIX = `${CATEGORY_BASE_EVENT}:organize`;

export const CATEGORY_EVENT = <const>{
	ADD: `${CATEGORY_BASE_EVENT}:add`,
	DELETE: `${CATEGORY_BASE_EVENT}:delete`,
	EDIT: `${CATEGORY_BASE_EVENT}:edit`,
	IMPORT: `${CATEGORY_BASE_EVENT}:import`,
	ORGANIZE_ASSETS: `${CATEGORY_BASE_EVENT}:organize:assets`,
	SHOW_ORGANIZE_ASSETS: `${CATEGORY_BASE_EVENT}:organize:assets:show`,
	SEARCH_ALL_ASSETS: `${CATEGORY_BASE_EVENT}:search:listAll`,

	CREATE_PDF: `${CATEGORY_BASE_EVENT}:createPDF:react`,
	CREATE_PDF_SHARE_LINK: `${CATEGORY_BASE_EVENT}:createPDF:shareLink`,
	CREATE_PDF_DOWNLOAD: `${CATEGORY_BASE_EVENT}:createPDF:download`,
	DOWNLOAD: `${CATEGORY_BASE_EVENT}:download`,
	MENU: `${CATEGORY_BASE_EVENT}:menu:react`,
	SHARE_LINK: `${CATEGORY_BASE_EVENT}:share:link`,

	ORGANIZE_ASSETS_ERROR: `${ORGANIZE_ASSETS_EVENT_PREFIX}:error`,
	ORGANIZE_ASSETS_SUCCESS: `${ORGANIZE_ASSETS_EVENT_PREFIX}:success`,
};
